// Copyright (c) Microsoft. All rights reserved.

import { Button, Tooltip, makeStyles } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useChat } from '../../../../libs/hooks';
import { Add20 } from '../../../shared/BundledIcons';

const useClasses = makeStyles({
    addButton: {
        // to align the button with the chat list
        marginLeft: '-8px',
    },
});

export const AbtisNewBotButton = () => {
    const classes = useClasses();
    const chat = useChat();
    const { t } = useTranslation();

    const onAddChat = () => {
        void chat.createChat();
    };

    return (
        <div>
            <Tooltip content={t('AddChat')} relationship="label">
                <Button className={classes.addButton} icon={<Add20 />} appearance="transparent" onClick={onAddChat} />
            </Tooltip>
        </div>
    );
};
